import type { artBoardActions } from '@store/reducers/artboard'
import { call } from 'redux-saga/effects'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'

// One place for the analytics, because the panel has three entry points — the
// header button, the project menu and the Cmd+F hotkey — and the hotkey was
// the one that used to open it without an event.
//
// Each of them dispatches `showStructure: true` only from a closed panel, so
// this fires once per open rather than once per keypress.
export function* trackStructureOpen({
  payload,
}: ReturnType<typeof artBoardActions.showStructure>) {
  if (!payload.showStructure) {
    return
  }

  yield call(sendGtmEvent, GtmTriggerName.STRUCTURE_OPEN)
}
